import register from '../register.js';

export default register( 'field-survey', () => {

  const nextBtn = document.querySelector('.fs-next');
  const progressBar = document.querySelector('.fs-progress-bar');
  let width = 0;

  nextBtn.addEventListener( 'click', () => {

    if ( width < 100 ) {
      width += 25;
      progressBar.style.width = `${ width }%`;
    }

  });

});
